import { loadIndexes } from '@data/indexes';
import type { Profil } from '@data/schemas';
import { normalize } from '@features/search';
import { html } from 'lit';
import { buildHref } from '../router';

export async function renderProfilsPage(): Promise<unknown> {
  const idx = await loadIndexes();
  const profils = idx.bdd.profils.profils;

  const matches = (p: Profil, q: string): boolean => {
    const text = normalize(`${p.nom} ${p.famille_id} ${p.caracteristiques_prioritaires.join(' ')}`);
    return text.includes(q);
  };

  const render = (p: Profil) => html`
    <a href=${buildHref('profil', { id: p.id })} class="list-card" data-tilt>
      <span class="list-card-badge">${p.famille_id}</span>
      <span class="list-card-title">${p.nom}</span>
      <span class="list-card-sub">${p.caracteristiques_prioritaires.join(', ')}</span>
      <span class="list-card-meta">${p.voies_classe_ids.length} voies · PV ${p.pv_par_niveau}/niv</span>
    </a>
  `;

  return html`
    <div class="list-page">
      <header class="list-page-header">
        <h1 class="list-page-title" data-morph data-morph-duration="1500">Profils</h1>
        <p class="list-page-subtitle">${profils.length} profils repartis en 4 familles. Choisissez-en un au niveau 1.</p>
      </header>
      <cof2-search-grid
        .items=${profils}
        .predicate=${matches}
        .renderItem=${render}
        placeholder="Rechercher un profil..."
      ></cof2-search-grid>
    </div>
  `;
}
